import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { EwMaIntegrationService } from './ew-ma-integration.service';
import { TranslateService } from '@ngx-translate/core';
import { EwMaIntegrationTranslateService } from './services/ew-ma-integration-translate.service';



@Component({
  selector: 'lib-ew-ma-integration',
  template: `
  <lib-integration (add_integration)="addIntegration.emit($event)" [default_lang]="default_lang"></lib-integration>
  <!-- <lib-add-itegration *ngIf="add_integration" [serviceName]="service_name"></lib-add-itegration> -->
  `,
  styles: [
  ]
})
export class EwMaIntegrationComponent implements OnInit, OnChanges {

  /**
   * @description
   * Event id from parent component.
   */
  @Input() event_id: string = '';
  @Input() default_lang: string = 'en';
  // public add_integration: boolean = false;
  public service_name: string;
  @Output() addIntegration: any = new EventEmitter();
  
  /**
   * 
   * @param integrationService 
   * @param ewTranslateService
   * @param translate
   */
  constructor(
    private integrationService: EwMaIntegrationService,
    private ewTranslateService: EwMaIntegrationTranslateService,
    public translate: TranslateService,
  ) { 
    translate.addLangs(["en", "es"]);
  }

  ngOnInit(): void {
    this.integrationService.event_id = this.event_id;
    this.initLanguage();
  }

  initLanguage() {
    this.translate.setDefaultLang(this.default_lang);
    
    this.translate.use(this.default_lang).subscribe(() => {
      this.ewTranslateService.init();
    });
  }

  ngOnChanges(): void {
    this.integrationService.event_id = this.event_id;
  }

  // addIntegration(event){
  //   this.add_integration = true;
  //   this.service_name = event;
  // }

}
